import React from "react";

const PromoSection = () => (
  <div className="bg-gray-700 p-4 rounded-lg shadow text-center mt-8">
    <p className="text-lg">Profit like a pro with 1-click copy trading</p>
  </div>
);

export default PromoSection;
